import { FC } from 'react';
import { useForm } from 'react-final-form';
import CommunicationsWarningModal from 'src/admin/common/components/CommunicationsWarningModal';
import { TripCartFormState } from 'src/listing/types';
import TripCartDrawer from 'src/trip-cart-deprecated/components/drawer/TripCartDrawer';
import { useTripCartBookingContext } from 'src/trip-cart-deprecated/hooks/useTripCartBookingContext';
import TripCartAsideRoot from 'src/trip-cart-deprecated/components/aside/TripCartAsideRoot';

/**
  Organization structure:
  - `aside/` contains components for Aside (desktop) only
  - `drawer/` contains components for BottomDrawer (mobile) only
  - `panel/` contains "screens" or "pages" (i.e. the full drawer or aside section)
     used in both BottomDrawer and Aside
  - `/` contains all other components that are shared in multiple places
*/
const TripCartRootContent: FC = () => {
  const { contentWarningVisible } = useTripCartBookingContext();
  const { submit } = useForm<TripCartFormState>();

  return (
    <>
      <TripCartDrawer />
      <TripCartAsideRoot />
      <CommunicationsWarningModal
        isOpen={contentWarningVisible}
        handleSubmit={submit}
      />
    </>
  );
};

export default TripCartRootContent;
